export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 3-1_05.e09b7e36.jpg";